import React from 'react';
import ProductBox from '../productBox/ProductBox';

const PlanTable = ({ products }) => {
  return (
    <div className="container mx-auto flex justify-center">
      <div className={`grid grid-cols-1 ${products.length >= 2 ? 'md:grid-cols-2' : ''} ${products.length >= 3 ? 'lg:grid-cols-3' : ''} ${products.length >= 4 ? 'xl:grid-cols-4' : ''} gap-6 pt-6`}>
        {products.map((product, index) => (
          <ProductBox product={product} key={index} />
        ))}
      </div>
    </div>
  );
};

export default PlanTable;
